import { Paper, Table, TableBody, TableContainer, Typography } from "@mui/material";

import LoadingIndicator from "../../Common/LoadingIndicator/LoadingIndicator";

import PaymentsListItem from "./PaymentsListItem";
import PaymentsTableHeader from "./PaymentsTableHeader";

export default function PaymentsTable({
  data = [],
  isLoading,
  onDelete,
  onEdit,
  canEdit = false,
  canDelete = false,
}) {
  if (isLoading) {
    return <LoadingIndicator />;
  }

  if (!data.length) {
    return <Typography className="text-center">No payments</Typography>;
  }

  return (
    <TableContainer component={Paper} className="shadow-none [&::-webkit-scrollbar-thumb]:bg-blue-700 [&::-webkit-scrollbar]:[width:6px]">
      <Table aria-label="payments collapsible table">
        <PaymentsTableHeader showActions={canEdit || canDelete} />
        <TableBody>
          {data.map((payment) => (
            <PaymentsListItem
              key={payment.id}
              data={payment}
              onDelete={onDelete}
              onEdit={onEdit}
              canEdit={canEdit}
              canDelete={canDelete}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
